<template>
	<div class="driver-stats-container d-flex align-center h-100">
		<!-- DYNAMIC STATS CELLS (Strictly fixed 80px each) -->
		<div v-for="opt in props.selectedColumns" :key="opt.value" class="stat-data-cell d-flex align-center justify-center border-right h-100">
			<template v-if="opt.value === 'preferences_fulfilment'">
				<v-icon size="14" :color="satisfactionStatus.color">
					{{ satisfactionStatus.icon }}
				</v-icon>
			</template>

			<span v-else class="text-caption font-weight-medium">
				{{ getStatValue(opt.value) }}
			</span>
		</div>

		<div v-if="planningBridge.editor.superuser" class="stat-data-cell debug-cell d-flex align-center justify-center border-right h-100">
			<v-icon size="15" @click="openDriverDebugView(props.driver._id)" style="cursor: pointer">mdi-bug</v-icon>
		</div>

		<Transition v-if="planningBridge.editor.superuser" name="fade">
			<DriverDebug v-if="showDriverDebugView" :driver-id="selectedDebugDriverId" @close="showDriverDebugView = false" />
		</Transition>
	</div>
</template>

<script setup lang="ts">
import { useDriverStatistics } from '../../services/useDriverStats';
import { ApiDriverUser } from '../../types/api/users-response';
import { StatOption } from '../../types/components/types';
import DriverDebug from '@/rennovation/planning-view/components/Presentation/DriverDebug.vue';
import { ref } from 'vue';
import { usePlanningBridgeStore } from '@/rennovation/planning-view/store/bridge/planningBridge';

const props = defineProps<{
	driver: ApiDriverUser;
	selectedColumns: StatOption[];
}>();

// Initialize the logic
const { satisfactionStatus, getStatValue } = useDriverStatistics(() => props.driver);
const planningBridge = usePlanningBridgeStore();

const selectedDebugDriverId = ref<string | null>(null);
const showDriverDebugView = ref(false);

const openDriverDebugView = (driverId: string) => {
	if (!driverId) return;
	selectedDebugDriverId.value = driverId;
	showDriverDebugView.value = true;
};
</script>

<style scoped>
.driver-stats-container {
	width: 100%;
	height: 100%;
}

.stat-data-cell {
	width: 80px !important;
	min-width: 80px !important;
	max-width: 80px !important;
	flex: 0 0 80px !important;
	box-sizing: border-box;
}

.border-right {
	border-right: 1px solid #eee;
}
</style>
